export type MachineStatusApi = 'USABLE' | 'FAULTY' | 'BROKEN' | 'DEPRECATED';

export const MACHINE_STATUS_OPTIONS: { value: MachineStatusApi; label: string }[] = [
  { value: 'USABLE', label: 'Utilizable' },
  { value: 'FAULTY', label: 'Con fallas' },
  { value: 'BROKEN', label: 'Rota' },
  { value: 'DEPRECATED', label: 'Deprecada' },
];

export function machineStatusLabel(status: MachineStatusApi): string {
  return MACHINE_STATUS_OPTIONS.find((o) => o.value === status)?.label ?? status;
}

export function machineStatusBadgeClass(status: MachineStatusApi): string {
  switch (status) {
    case 'USABLE':
      return 'badge-machine badge-machine-usable';
    case 'FAULTY':
      return 'badge-machine badge-machine-faulty';
    case 'BROKEN':
      return 'badge-machine badge-machine-broken';
    case 'DEPRECATED':
      return 'badge-machine badge-machine-deprecated';
    default:
      return 'badge-machine';
  }
}

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
